import React from 'react';
import NewVerticalStack from './NewVerticalStack';

const VerticalStackPicker = (props) => {
  return <NewVerticalStack {...props} />;
};

export default VerticalStackPicker;
